import {useState, useEffect} from 'react';
import {Col, Drawer, Row} from 'antd';
import {TFunction, withTranslation} from 'react-i18next';
import Container from '../../common/Container';
import {SvgIcon} from '../../common/SvgIcon';
import {
    Burger,
    CustomNavLinkSmall,
    HeaderCTA,
    HeaderSection,
    Label,
    LogoContainer,
    Menu,
    NotHidden,
    Outline,
    Span,
} from './styles';

const Header = ({t}: { t: TFunction }) => {
    const [visible, setVisibility] = useState(false);
    const [scrolled, setScrolled] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            setScrolled(window.scrollY > 50);
        };
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const toggleButton = () => {
        setVisibility(!visible);
    };

    const scrollTo = (id: string) => {
        const element = document.getElementById(id) as HTMLDivElement;
        element.scrollIntoView({
            behavior: 'smooth',
        });
        setVisibility(false);
    };

    const MenuItem = () => {
        return (
            <>
                <CustomNavLinkSmall onClick={() => scrollTo('features')}>
                    <Span>{t('Fonctionnalités')}</Span>
                </CustomNavLinkSmall>
                <CustomNavLinkSmall onClick={() => scrollTo('pricing')}>
                    <Span>{t('Tarifs')}</Span>
                </CustomNavLinkSmall>
                <CustomNavLinkSmall onClick={() => scrollTo('faq')}>
                    <Span>{t('FAQ')}</Span>
                </CustomNavLinkSmall>
                <CustomNavLinkSmall onClick={() => scrollTo('contact')}>
                    <Span>{t('Contact')}</Span>
                </CustomNavLinkSmall>
                <HeaderCTA onClick={() => window.open('https://prod.opendaara.com/', '_blank')}>
                    Commencez gratuitement
                </HeaderCTA>
            </>
        );
    };

    return (
        <HeaderSection scrolled={scrolled}>
            <Container>
                <Row justify="space-between">
                    <LogoContainer to="/" aria-label="homepage">
                        <SvgIcon src="open.svg" width="150px" height="100px"/>
                    </LogoContainer>
                    <NotHidden>
                        <MenuItem/>
                    </NotHidden>
                    <Burger onClick={toggleButton}>
                        <Outline/>
                    </Burger>
                </Row>
                <Drawer closable={false} open={visible} onClose={toggleButton}>
                    <Col style={{marginBottom: '2.5rem'}}>
                        <Label onClick={toggleButton}>
                            <Col span={12}>
                                <Menu>Menu</Menu>
                            </Col>
                            <Col span={12}>
                                <Outline/>
                            </Col>
                        </Label>
                    </Col>
                    <MenuItem/>
                </Drawer>
            </Container>
        </HeaderSection>
    );
};

export default withTranslation()(Header);
